export default __webpack_public_path__ + "static/media/Vertical_AHU_2_selected.9b7b3023.svg";